import { createUseStyles } from 'react-jss';

import { FontWeight, ITheme, mediaQuery } from '../../../styles';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    label: {
      fontSize: 14,
      fontWeight: FontWeight.Medium,
      lineHeight: '20px',
      color: 'var(--x-text-color-2)',
      textAlign: 'center',
      marginBlockEnd: 4,
    },

    title: {
      color: 'var(--x-accent-2-1)',
      fontWeight: FontWeight.Medium,
      fontSize: 30,
      lineHeight: '36px',
      marginBlockEnd: 48,
      textAlign: 'center',

      [mediaQuery(breakpoints.mobile)]: {
        marginBlockEnd: 24,
      },
    },

    list: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: 8,
      listStyleType: 'none',
      marginInline: 'auto',
      width: 'min(960px, 100%)',

      [mediaQuery(breakpoints.mobile)]: {
        gridTemplateColumns: '1fr',
      },
    },

    textContainer: {
      marginInlineStart: 20,
    },

    link: {
      width: '100%',
      textDecoration: 'none',
      color: 'var(--x-text-color-4)',
      alignItems: 'center',
      display: 'inline-flex',
      marginBlockEnd: 32,
      padding: 8,
      '&:hover': {
        boxShadow: '0px 4px 16px rgba(17, 18, 54, 0.16)',
        borderRadius: '16px',
      },

      [mediaQuery(breakpoints.tablet)]: {
        marginBlockEnd: 16,
      },
    },

    imgContainer: {
      width: 64,
      height: 64,
      marginInlineEnd: 20,
    },

    name: {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: '20px',
      marginBlockEnd: 4,
      color: 'var(--x-text-color-5)',
    },

    description: {
      alignItems: 'center',
      display: 'flex',
      fontSize: 14,
      lineHeight: '20px',
    },

    icon: {
      height: 16,
      marginInlineStart: 8,
      width: 16,

      '& path': {
        fill: 'var(--x-text-color-4)',
      },
    },
  }),
  { name: 'navbar' },
);

export default useStyles;
